//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import { convertRequestPriority } from '../../components/helpers.js'
import Table from '../../components/Table/Table.vue'

export default {
  name: 'TaskProposedTasksGroups',
  components: {
    Table
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    group: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data: function () {
    return {
      opened: false,
      columns: [
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          field: 'name',
          sortable: true
        }
      ],
      loading: false,
      formatRequestPriority: convertRequestPriority,

      callback: null,
      header: 'Добавление в группу заданий',
      groups: [],
      selectedGroup: null
    }
  },
  methods: {
    select: function (callback) {
      this.callback = callback
      this.opened = true

      this.loading = true
      axiosGet({
        url: '/service/delta/request/group/proposeRequestGroups?requestId=' + this.request.requestId,
        onSuccess: (response) => {
          this.groups = response.data.result
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    confirm: async function () {
      if (this.selectedGroup == null) {
        if (this.groups.length === 1) {
          this.selectedGroup = this.groups[0]
        } else {
          this.$q.notify({
            type: 'negative',
            message: 'Не выбрана группа заданий!',
            progress: true,
            timeout: 8000
          })

          return
        }
      }
      const result = {
        groupId: this.selectedGroup.id
      }
      try {
        await this.callback(result)
        this.close()
      } catch (e) {
        console.log(e)
      }
    },
    close () {
      this.opened = false
      this.clearValue()
    },
    clearValue () {
      this.groups = []
      this.selectedGroup = null
    },

    selectTableItem: function (item) {
      this.selectedGroup = item
    },
    openTableTask: function (task) {
      this.$router.push('/task/' + task.id)
    }
  }
}
